export default __webpack_public_path__ + "static/media/rmcm01.85690536.png";